import { Component, OnInit } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';
import { Router, ActivatedRoute } from '@angular/router';

import moment from 'moment';
declare var require: any

@Component({
  selector: 'app-timesheets',
  templateUrl: './timesheets.component.html',
  styleUrls: ['./timesheets.component.scss']
})
export class TimesheetsComponent implements OnInit {

  timesheets: any;
  filter: any;
  view : any;
  group: any;
  selected : any;
  worker_id : any;

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };

    this.worker_id=null;

    this.getTimesheets();

  }

  getTimesheets(){


    this.updateFilter();

    //console.log(this.filter);

    this.okService.get("reports/timesheets",this.filter)
    .subscribe((data) => {

      this.timesheets = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;
      // this.timesheets = data['result']['timesheets'];
      // this.filter = data['result']['filter'];

      //console.log("Timesheets",this.timesheets);

    });
  }


  updateFilter(){


    this.filter = [];
    this.filter['start'] = this.selected.startDate.format("YYYY-MM-DD");
    this.filter['end'] = this.selected.endDate.format("YYYY-MM-DD");
    this.filter['page'] = this.pagination.page;

    if(this.worker_id){
      this.filter['worker_id'] = this.worker_id;
    }

    if(this.group){
      this.filter['group'] = this.group;
    }

    //console.log(this.filter);

  }

  export(){

    this.updateFilter();


    this.okService.download("reports/timesheetsexport",this.filter);
  }


}
